import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../api/client";
import {
  formatListItems,
  formatSpecialityListItems,
} from "../../../service/utils";

const initialState = {
  getCountriesLoader: false,
  countriesData: [],
  statesData: [],
  getCitiesByStateLoader: false,
  citiesData: [],
  getSpecialitiesLoader: false,
  specialitiesData: [],
  filteredProviders: [],
};

export const getCountries = createAsyncThunk(
  "formField/getCountries",
  async () => {
    const response = await client.get(
      `/o/providersearch/providers?p_auth=${window.Liferay.authToken}`
    );
    return response;
  }
);

export const getStatesByCountry = createAsyncThunk(
  "formField/getStatesByCountry",
  async (countryId) => {
    const response = await client.get(
      `/o/providersearch/providers?country=${countryId}&p_auth=${window.Liferay.authToken}`
    );
    return response;
  }
);

export const getCitiesByState = createAsyncThunk(
  "formField/getCitiesByState",
  async ({country, state}) => {
    const response = await client.get(
      `/o/providersearch/providers?country=${country}&state=${state}&p_auth=${window.Liferay.authToken}`
    );
    return response;
  }
);

export const getSpecialities = createAsyncThunk(
  "formField/getSpecialities",
  async () => {
    const response = await client.get(
      `/o/providersearch/providers?speciality=true&p_auth=${window.Liferay.authToken}`
    );
    return response;
  }
);

export const formFieldSlice = createSlice({
  name: "formField",
  initialState,
  reducers: {
    resetStateField: (state) => {
      state.statesData = [];
    },
    resetCityField: (state) => {
      state.citiesData = [];
    },
  },
  extraReducers: {
    [getCountries.pending]: (state, action) => {
      state.getCountriesLoader = true;
    },
    [getCountries.fulfilled]: (state, action) => {
      state.getCountriesLoader = false;
      const countriesList = action.payload.countries;
      state.countriesData = formatListItems(countriesList);
    },
    [getCountries.rejected]: (state, action) => {
      state.getCountriesLoader = false;
      state.error = action.payload;
    },
    [getStatesByCountry.pending]: (state, action) => {
      state.getStatesByCountryLoader = true;
    },
    [getStatesByCountry.fulfilled]: (state, action) => {
      state.getStatesByCountryLoader = false;
      const statesList = action.payload.states;
      state.statesData = formatListItems(statesList);
    },
    [getStatesByCountry.rejected]: (state, action) => {
      state.getStatesByCountryLoader = true;
    },
    [getCitiesByState.pending]: (state, action) => {
      state.getCitiesByStateLoader = true;
    },
    [getCitiesByState.fulfilled]: (state, action) => {
      state.getCitiesByStateLoader = false;
      const citiesList = action.payload.cities;
      state.citiesData = formatListItems(citiesList);
    },
    [getCitiesByState.rejected]: (state, action) => {
      state.getCitiesByStateLoader = false;
      state.error = action.payload;
    },
    [getSpecialities.pending]: (state, action) => {
      state.getSpecialitiesLoader = true;
    },
    [getSpecialities.fulfilled]: (state, action) => {
      state.getSpecialitiesLoader = false;
      const specialitiesList = action.payload.specialities;
      state.specialitiesData = formatSpecialityListItems(specialitiesList);
    },
    [getSpecialities.rejected]: (state, action) => {
      state.getSpecialitiesLoader = false;
      state.error = action.payload;
    },
  },
});

export const { resetStateField, resetCityField } = formFieldSlice.actions;

export default formFieldSlice.reducer;
